<template>
  <QAutoComplete :value="value" :label="label ? label : $t('servicesystem.common_objects.job.priority')"
    :placeholder="placeholder" :disabled="disabled" :loading="loading" :list="options" :textkey="'Name'"
    :valuekey="'Id'" :multiple="multiple" :clearable="clearable" :externaledit="externaledit"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$job_priority</v-icon>
    </template>

  </QAutoComplete>
</template>


<script>
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "JobPrioritySelect",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    multiple: Boolean,
    hideIcon: Boolean,
  },
  components: {},
  mixins: [rules],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    options() {
      var list = this.$store.getters["LookUpStore/JobPriorityList"];
      return list && list.length ? list : [];
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>